import React from "react"
import CustomCalendarDay from "../CustomCalendarDay"
import { CalendarDate, CalendarWeekDates } from "../types"
import { dateEquals } from "../utils"
import classes from "./CustomCalendarWeek.module.css"

interface Props {
  dates: CalendarWeekDates
  selectable?: (date: CalendarDate) => boolean
  onSelect?: (date: CalendarDate) => void
  selectedDate?: CalendarDate
}

const CustomCalendarWeek = ({
  dates,
  selectedDate,
  selectable,
  onSelect,
}: Props) => {
  return (
    <div className={classes.row}>
      {dates.map((x, index) => (
        <CustomCalendarDay
          date={x}
          key={index}
          className={classes.day}
          selected={x && selectedDate && dateEquals(x, selectedDate)}
          clickable={(x && selectable?.(x)) ?? false}
          onClick={() => x && onSelect?.(x)}
        />
      ))}
    </div>
  )
}

export default CustomCalendarWeek
